// college-modal.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from './modal.service';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-college-modal',
  templateUrl: './college-modal.component.html',
  styleUrls: ['./college-modal.component.scss']
})
export class CollegeModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  modalType = '';
  modalAction = '';
  modalData: any = null;
  modalTitle = '';
  private routerSubscription: Subscription;

  constructor(
    private modalService: ModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute  // Corrected spelling
  ) {}

  ngOnInit() {
    this.modalService.getModalState().subscribe(state => {
      this.isOpen = state.isOpen;
      this.modalType = state.type;
      this.modalAction = state.action;
      this.modalData = state.data;
      this.modalTitle = this.getModalTitle();
    });

    // Listen for navigation events to close modal when route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isOpen) {
          this.closeModal();
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  closeModal() {
    this.modalService.closeModal();
    // Navigate back to the main page without the modal route
    this.router.navigate(['../'], { relativeTo: this.activatedRoute, skipLocationChange: true });
  }

  getModalTitle(): string {
    const action = this.modalAction === 'add' ? 'Add' : 'Edit';
    const titles = {
      'address': 'Address',
      'contact': 'Contact',
      'university': 'University',
      'entranceexam': 'Entrance Exam',
      'ranking': 'Ranking',
      'accreditation': 'Accreditation',
      'branch': 'Branch',
      'info': 'Information',
      'document': 'Document',
      'gallery': 'Gallery Item',
      'application': 'Application',
      'course': 'Course',
      'scholarship': 'Scholarship',
      'placement': 'Placement',
      'review': 'Review',
      'news': 'News'
    };
    
    return `${action} ${titles[this.modalType] || 'Item'}`;
  }

  onFormSuccess() {
    this.closeModal();
  }
}